import { render, staticRenderFns } from "./relatorioParcelasARegularizarPaisagem.vue?vue&type=template&id=2dea2342"
import script from "./relatorioParcelasARegularizarPaisagem.vue?vue&type=script&lang=js"
export * from "./relatorioParcelasARegularizarPaisagem.vue?vue&type=script&lang=js"
import style0 from "./relatorioParcelasARegularizarPaisagem.vue?vue&type=style&index=0&id=2dea2342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports